export default class ContactInfoValidUtil {

  static isPhone(str: string) {
    if(str && str.length > 0){
      if(str[0] === "+"){
        str = str.substring(1);
      }
      return /^\d+$/.test(str);
    }
    return false;
  }

  static isPhonePattern(phone: string) {
    return phone ? phone.length >= 10 && phone.length <= 14 : false;
  }
  
  static isEmailPattern(email: string) {
    if (!email || email.length > 254) {
      return false;
    }
    const localPart = email.split("@")[0];
    if (localPart.length < 1 || localPart.length > 64) {
      return false;
    }
    const allowedChars = /^[A-Za-z0-9._+-]+@[A-Za-z0-9._+-]+\.[A-Za-z0-9._+-]{2,}$/;
    return allowedChars.test(email);
  }
}
